<template>
  <div>
    <template
      v-if="
        [IMAGE_TYPES.IMAGE, IMAGE_TYPES.VIDEO, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.META, IMAGE_TYPES.PLAYABLE].includes(landData.imageType)
      "
    >
      <slot name="exclude-media"></slot>
      <el-form-item label="素材样式" prop="imageStyles">
        <el-cascader
          v-model="landData.imageStyles"
          clearable
          filterable
          style="width: 420px"
          :props="{ label: 'content', value: 'labelId', multiple: true }"
          :options="imageStyleTagList"
        >
          <template slot-scope="{ data }">
            <span>
              <span v-if="data.content.includes('制作方式') || data.content.includes('素材来源')">
                <em style="color: red; font-weight: 700">*</em> {{ data.content }}
              </span>
              <span v-else>{{ data.content }}</span>
            </span>
          </template>
        </el-cascader>
      </el-form-item>
    </template>

    <el-form-item label="3D视频源（可多选）">
      <el-select v-model="landData.videoLabelIds" multiple filterable style="width: 420px">
        <el-option v-for="item in threedLabeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="设计师" prop="opId" :key="landData.imageType + 'opId'">
      <el-select v-model="landData.opId" filterable style="width: 420px">
        <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"> </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="策划师">
      <el-select v-model="landData.plannerId" multiple filterable style="width: 420px">
        <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { IMAGE_STYLE, IMAGE_TYPES } from '../consts.js'
import { initPageData, SYS_USERS } from '@/data/global-opts'
import { useLabels } from '../hooks/useLabelRelations.js'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Object,
    required: true
  }
})
const landData = computed(() => props.value)

const operatorData = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const { contentLabelList, threedLabeList, imageStyleTagList, tagGroupsList } = useLabels(landData)
</script>

<style scoped lang="scss"></style>
